import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const organizationCollection = collection(db, "organizations_master_data");

const organizationService = {
  getAll: async () => {
    try {
      const organizationSnapshot = await getDocs(organizationCollection);
      const organizationList = organizationSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return organizationList;
    } catch (error) {
      console.error('Error fetching organization master data:', error);
      throw error;
    }
  },
  add: async (organizationData) => {
    try {
      const docRef = await addDoc(organizationCollection, organizationData);
      return docRef;
    } catch (error) {
      console.error('Error adding organization master data:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const organizationRef = doc(db, 'organizations_master_data', id);
      await updateDoc(organizationRef, data);
    } catch (error) {
      console.error('Error updating organization master data:', error);
      throw error;
    }
  },
  delete: async (organizationId) => {
    try {
      await deleteDoc(doc(db, "organizations_master_data", organizationId));
      return true;
    } catch (error) {
      console.error('Error deleting organization master data:', error);
      throw error;
    }
  },
  getNameById: async (organizationId) => {
    try {
      const organizationRef = doc(db, 'organizations_master_data', organizationId);
      const organizationSnap = await getDoc(organizationRef);

      if (organizationSnap.exists()) {
        return organizationSnap.data().name;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting organization name:', error);
      throw error;
    }
  },
  getAPONumberById: async (organizationId) => {
    try {
      const organizationRef = doc(db, 'organizations_master_data', organizationId);
      const organizationSnap = await getDoc(organizationRef);

      if (organizationSnap.exists()) {
        return organizationSnap.data().APO_number;
      } else {
        return null;
      }
    }
    catch (error) {
      console.error('Error getting organization APO Number:', error);
      throw error;
    }
  },
  getById: async (organizationId) => {
    try {
      const organizationRef = doc(db, 'organizations_master_data', organizationId);
      const organizationSnap = await getDoc(organizationRef);

      if (organizationSnap.exists()) {
        return {
          id: organizationSnap.id,
          ...organizationSnap.data()
        };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting organization data:', error);
      throw error;
    }
  }
};

export default organizationService;